import { isBrowser } from './isBrowser';

export function isSafari(): boolean {
  if (!isBrowser()) {
    return false;
  }

  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
